export const printIsoDateString = (isoDateTime: string): string => {
    const d = new Date(isoDateTime);
    return d.toLocaleString();
}